import React from "react";
import styles from "./DevelopersTabs.module.scss";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Overview from "component/overview/Overview";
import ApiKeyCreate from "component/apiKeyCreate/ApiKeyCreate";
import WebhookCreate from "component/webhookCreate/WebhookCreate";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index && <div className={` ${styles.main}`}>{children}</div>}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

export default function DevelopersTabs() {
	const [value, setValue] = React.useState(0);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	return (
		<div className={` ${styles.tabs}`}>
			<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
				<Tab label="Overview" {...a11yProps(0)} />
				<Tab label="API Keys" {...a11yProps(1)} />
				<Tab label="Webhooks" {...a11yProps(2)} />
				{/* <Tab label="Usage" {...a11yProps(3)} /> */}
			</Tabs>

			<CustomTabPanel value={value} index={0}>
				<Overview onNext={() => setValue(1)} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<ApiKeyCreate />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={2}>
				<WebhookCreate />
			</CustomTabPanel>
			{/* <CustomTabPanel value={value} index={3}>
				Item 4
			</CustomTabPanel> */}
		</div>
	);
}
